import React__default from 'react';
import classNames from 'classnames';
import { SkeletonBodyText } from '@shopify/polaris';
import styles from './TopBar.scss.mjs';
import { useFeatures } from '../FeaturesProvider/FeaturesProvider.mjs';
import { Divider } from './components/Divider/Divider.mjs';
import { ExitAction } from './components/ExitAction/ExitAction.mjs';
import { LayoutGroup } from './components/LayoutGroup/LayoutGroup.mjs';

function TopBar({
  loading,
  slim,
  children
}) {
  const {
    usesBottomSheet
  } = useFeatures();
  const topBarClassNames = classNames(styles.TopBar, {
    [styles.loading]: loading,
    [styles.slim]: slim,
    [styles.usesBottomSheet]: usesBottomSheet
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: topBarClassNames
  }, loading ? LoadingSkeleton() : children);
}
function LoadingSkeleton() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.LoadingSkeleton
  }, /*#__PURE__*/React__default.createElement(SkeletonBodyText, {
    lines: 1
  }), /*#__PURE__*/React__default.createElement(SkeletonBodyText, {
    lines: 1
  }), /*#__PURE__*/React__default.createElement(SkeletonBodyText, {
    lines: 1
  }));
}
TopBar.Divider = Divider;
TopBar.ExitAction = ExitAction;
TopBar.LayoutGroup = LayoutGroup;

export { TopBar };
